import React, { useContext } from "react";
import "./dynamicposts.css";
import { AllPostContext } from "../../contextStore/AllPostContext";
import PostCards from "../PostCards/PostCards";
import { Link } from "react-router-dom";

function DynamicPosts({ category }) {
  const { allPost } = useContext(AllPostContext);
  const displayCards = allPost
    .filter((itm) => itm.category === category)
    .map((product, index) => (
      <PostCards product={product} index={index} key={index} />
    ));

  return (
    <>
      {category !== "null" && (
        <div className="moreViewSection">
          <div className="moreViewHeader">
            <h2 className="heading-title">{category}</h2>
            <Link to="/viewmore" className="heading-link">
              View more →
            </Link>
          </div>

          <div className="cardsWrapper">
            {displayCards.length > 0 ? (
              <div className="cardsScroll">{displayCards}</div>
            ) : (
              <div className="noPosts">No machines found in this category.</div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default DynamicPosts;
